export const emptyDashboardFilterGroup = {
  selectedAcceptState: [],
  selectedArticle: [],
  selectedArticleNumber: [],
  selectedCategory: [],
  selectedCostCenter: [],
  selectedCustomerNumber: [],
  selectedCustomFields: [],
  selectedFromSite: [],
  selectedOuId: [],
  selectedPermittedCostCenters: [],
  selectedPermittedToSites: [],
  selectedProcessState: [],
  selectedRecipient: [],
  selectedSettledStatus: [],
  selectedSupplier: [],
  selectedToSiteRecipient: [],
  selectedToSiteSupplier: [],
  selectedToSiteSupplierTradeContact: [],
};
